
export default function AboutHero() {
  return (
    <section className="min-h-screen flex items-center justify-center bg-white relative overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/6651126df431830c78c4535196e8a46f.jpg')`
        }}
      >
        <div className="absolute inset-0 bg-white/75"></div>
      </div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h1 className="text-5xl md:text-7xl font-light text-gray-900 mb-6 leading-tight">
              Behind the 
              <span className="block font-medium">creative vision</span>
            </h1>
            
            <p className="text-xl md:text-2xl text-gray-600 mb-8 leading-relaxed">
              I'm Esteban Ramirez, an award-winning photographer, graphic designer, and art director based in Los Angeles. For more than 13 years, I've worked at the intersection of photography, design, and brand storytelling — creating visuals and experiences that connect with audiences in meaningful ways.
            </p>
            
            <div className="flex items-center space-x-8">
              <div>
                <div className="text-3xl font-light text-gray-900">150+</div>
                <div className="text-sm text-gray-600">Projects Completed</div>
              </div>
              <div>
                <div className="text-3xl font-light text-gray-900">13+</div>
                <div className="text-sm text-gray-600">Years Experience</div>
              </div>
            </div>
          </div>
          
          <div className="relative">
            <div className="bg-gray-100 rounded-sm p-8">
              <img 
                src="https://static.readdy.ai/image/3fdc746f0d1d84f2cde4df046cd392e8/39152c4c9b454c4ee459144d2add5432.jpeg"
                alt="Professional designer portrait"
                className="w-full h-auto object-cover object-top rounded-sm"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
